










import { Component, Prop, Vue } from 'vue-property-decorator'
import { EvaluationStatus } from '@/evaluations/entities/evaluation-status'
import * as states from '@/evaluations/utils/evaluation-states'

@Component
export default class EvaluationStatusBadge extends Vue {
  @Prop({ required: true })
  private status!: EvaluationStatus

  private get isDraft() {
    return states.isDraft(this.status)
  }

  private get isInProgress() {
    return states.isInProgress(this.status)
  }

  private get isFinished() {
    return states.isFinished(this.status)
  }
}
